import React from "react";
import "./Title.css";
function Title() {
  return (
    <>
      <div id="particles-js"></div>
      <div class="wrapper_title">
        <div class="loop_title">
          <span class="title1">Welcome to Kaito's website!</span>
          <span class="title2">
            My background and research will be posted here.
          </span>
          <span class="title3">Welcome to Kaito's website!</span>
          <span class="title4">
            My background and research will be posted here.
          </span>
        </div>
        <p class="scroll_begin">scroll to begin</p>
        <p class="arrow_u"></p>
      </div>
    </>
  );
}

export default Title;
